import { render, staticRenderFns } from "./assessmentList.vue?vue&type=template&id=4680961c&scoped=true"
import script from "./assessmentList.vue?vue&type=script&lang=js"
export * from "./assessmentList.vue?vue&type=script&lang=js"
import style0 from "./assessmentList.vue?vue&type=style&index=0&id=4680961c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4680961c",
  null
  
)

export default component.exports